import { PDFDocument, rgb } from 'pdf-lib'; // Importamos pdf-lib y rgb

// Función para agregar texto y una imagen (firma) al PDF
export async function addTextAndSignatureToPDF(existingPdfBytes, text, signatureDataUrl) {
  const pdfDoc = await PDFDocument.load(existingPdfBytes);

  // Usamos la fuente predeterminada del PDF
  const font = pdfDoc.embedStandardFont('Helvetica');

  // Crear una página y agregar el texto
  const pages = pdfDoc.getPages();
  const page = pages[0]; // Usamos la primera página para agregar texto

  // Obtener las dimensiones de la página
  const { width, height } = page.getSize();

  // Agregar el texto en la parte inferior izquierda
  const x = 40 + 5; //40 is the margin
  const y = 40 + 25; //40 is the margin

  page.drawText(text, {
    x: x,
    y: y,
    size: 16,
    font: font,
    color: rgb(0, 0, 0),
  });

  // Convertir la firma base64 a una imagen
  const signatureImage = await pdfDoc.embedPng(signatureDataUrl);  // Firma en formato PNG

  // Obtener las dimensiones de la imagen (firma)
  const signatureWidth = 200;
  const signatureHeight = signatureImage.height / (signatureImage.width / signatureWidth);

  // Agregar la firma en el PDF en la parte inferior
  page.drawImage(signatureImage, {
    x: 340,
    y: 40 + 5,  // Puedes ajustar la posición de la firma
    width: signatureWidth,
    height: signatureHeight,
  });

  // Guardar el PDF modificado
  const modifiedPdfBytes = await pdfDoc.save();
  return modifiedPdfBytes;
}
